import styled from "styled-components";
import theme from '../../../../../../../theme/theme';

export const ParagraphSixthStage = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  text-align: center;
  color: ${theme.colors.color4};
`

export const StyledImage = styled.div`
  background: ${theme.colors.green};
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 16px;
`

export const ContainerSixthStage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

`